var countdown = 30 * 60 * 1000;
var timerId = setInterval(function(){
  countdown -= 1000;
  var min = Math.floor(countdown / (60 * 1000));
  //var sec = Math.floor(countdown - (min * 60 * 1000));  // wrong
  var sec = Math.floor((countdown - (min * 60 * 1000)) / 1000);  //correct
  var correction = "0"+sec;

  if (countdown <= 0) {
    // alert("30 min!");
     clearInterval(timerId);
     //doSomething();
  } else {
    if (sec < 10) {
      $("#time").html(min + ":" + correction);
    } else {
      $("#time").html(min + ":" + sec);
    }
     
  }

}, 1000); //1000ms. = 1sec.